import axios from 'axios';

const getSolicitacao = (id) => axios.get(`/fornecedor/solicitacoes-respostas/${id}`);
const getMunicipios = (id) => axios.get(`/fornecedor/solicitacoes-respostas/${id}/municipios`);
const recusar = (id, data) => axios.put(`/fornecedor/solicitacoes-respostas/situacao/${id}`, data);

export default {
  getSolicitacao,
  getMunicipios,
  recusar,
};
